import { Box, Typography } from "@mui/material";
import { CanalDistribuicaoViewProps } from "../canalDist.controll";
import { GridColDef } from "@mui/x-data-grid";
import { formatMoney } from "../../../services/utils";
import { ResumoMpMovimentacoesByCanalDistProps } from "../canalDist.model";
import { StripedDataGrid, Select as ViewList } from "../../../components/select";
import { useEffect } from "react";
import { ResumoMeioPagRecebido } from "../../contas/contas.model";
import { red } from "../../../../ui/mui/shared-theme/themePrimitives";



const columns: GridColDef[] = [
    { field: 'descricaoMp', headerName: 'Meio de Pagamento', flex: 8 },
    { field: 'totalMp', headerName: 'Total', flex: 4, valueFormatter: (value) => formatMoney(value) },
]

const columnsDespesa: GridColDef[] = [
    { field: 'descricao', headerName: 'Descrição', flex: 8 },
    { field: 'valor', headerName: 'Valor', flex: 4, valueFormatter: (value) => formatMoney(value) },
]

export function CanalDistFinanceiro(props: CanalDistribuicaoViewProps) {
    const { row, resumoMovsMp, loadingRows, changeList } = props.canalDistribuicaoState
    const { resumoMeiopagRecebidos } = props.contasState
    const totalRecebimentos = resumoMovsMp.reduce((acc, mp) => acc + mp.totalMp, 0);
    const totalDespesas = row.despesas.reduce((acc, despesa) => acc + despesa.valor, 0);
    const totalContasRecebidos = resumoMeiopagRecebidos.reduce((acc, conta) => acc + conta.valor, 0)
    const saldoFinal = (totalRecebimentos + totalContasRecebidos) - totalDespesas;
    console.log("resumoMovsMp", props.canalDistribuicaoState);


    const ViewDespesas = () => {
        if (row.despesas.length === 0) {
            return (
                <Box sx={{ mt: 2 }}>
                    <Typography variant="subtitle1">Nenhuma despesa registrada.</Typography>
                </Box>
            );
        }
        return (
            <Box>
                <Typography variant="subtitle1" sx={{ mb: 1 }}>Despesas</Typography>
                <StripedDataGrid
                    disableRowSelectionOnClick
                    rows={row.despesas}
                    columns={columnsDespesa}
                    getRowId={(row) => row._id}
                    density={'compact'}
                    style={{ fontSize: '0.875rem' }}
                    hideFooterPagination={true}
                    hideFooter={true}
                    filterMode="client"
                />
                <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }}>
                    <Typography variant="subtitle1">Total Despesas:</Typography>
                    <Typography variant="subtitle1" color={red[300]}>{formatMoney(totalDespesas)}</Typography>
                </Box>
            </Box>
        )
    }

    const ViewContasRecebidas = () => {
        if (resumoMeiopagRecebidos.length > 0)
            return (
                <Box>
                    <Typography variant="subtitle1" sx={{ mb: 1 }}>Contas Recebidas</Typography>
                    <StripedDataGrid
                        disableRowSelectionOnClick
                        rows={resumoMeiopagRecebidos}
                        columns={columnsDespesa}
                        getRowId={row => row._id}
                        density={'compact'}
                        style={{ fontSize: '0.875rem' }}
                        hideFooterPagination={true}
                        hideFooter={true}
                        filterMode="client"
                        loading={props.contasState.loadingRows}
                    />
                    <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }}>
                        <Typography variant="subtitle1">Total Contas Recebidas:</Typography>
                        <Typography variant="subtitle1" color="success">{formatMoney(totalContasRecebidos)}</Typography>
                    </Box>
                </Box>
            )
        
            return (
                <Box sx={{ mt: 2 }}>
                    <Typography variant="subtitle1">Nenhuma conta recebida.</Typography>
                </Box>
            );            
        
    }

    return (
        <Box>
            <ViewList
                displayWidth={window.innerWidth}
                title={`Resumo Financeiro - Saldo: ${formatMoney(saldoFinal)}`}
                row={row}
                showAlert={false}
                closeAlert={() => { }}
                msg={""}
                status={""}
                elevation={1}
                getRowId={(row: ResumoMpMovimentacoesByCanalDistProps) => row.descricaoMp}
                handleOnChange={() => { }}
                actionsOnkeyEnter={() => { }}
                showSearchContainer={false}
                fontSize={14}
                setTextSearch={() => { }}
                textSearch={""}
                fieldSearch={"descricaoMp"}
                columns={columns}
                rows={resumoMovsMp}
                loading={loadingRows}
                setRow={() => { }}
                changeList={changeList}
                variantToobar="dense"
                buttonNew={{
                    show: false,
                    onClick: () => { }
                }}
                buttonRefresh={{
                    show: true,
                    onClick: () => props.canalDistribuicaoActions.getResumoMpMovByCanalDist()
                }}
                ListItemTextPrimary={(row: ResumoMpMovimentacoesByCanalDistProps) => <Typography component={"span"}>{row.descricaoMp}</Typography>}
                ListItemTextSecondary={(row: ResumoMpMovimentacoesByCanalDistProps) =>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Typography component={"span"}>{formatMoney(row.totalMp)}</Typography>
                    </Box>
                }

            />
            <Box sx={{ mt: 2, display: 'flex', flexDirection: "row", justifyContent: 'flex-end' }}>
                <Typography variant="subtitle1">Total Movimentações:</Typography>
                <Typography variant="subtitle1" color="success">{formatMoney(totalRecebimentos)}</Typography>
            </Box>
            <ViewContasRecebidas />
            <ViewDespesas />

        </Box>
    )
}